import type { I18n } from "@lingui/core";
import { msg } from "@lingui/macro";

const AUTH_ERRORS = [
  { pattern: /already exists/i, message: msg`User already exists` },
  {
    pattern: /wrong email or password/i,
    message: msg`Wrong email or password`,
  },
  {
    pattern:
      /error occured while trying to authorize|registration not possible/i,
    message: msg`Something went wrong`,
  },
];

const prepareNextAuthErrorMessage = (error: string, i18n: I18n): string => {
  const message = error.replace("Error: ", "");
  const known = AUTH_ERRORS.find(({ pattern }) => pattern.test(message));

  return known && i18n.messages[known.message.id]
    ? i18n._(known.message)
    : message;
};

export default prepareNextAuthErrorMessage;
